<template>
  <form novalidate @submit.prevent="submit">
    <v-text-field
      v-model="formData.title"
      v-validate="'required|min:4'"
      :error-messages="errors.collect('title')"
      :label="dictionary.attributes.title"
      data-vv-name="title"
      required
      :autofocus="autofocus"
    ></v-text-field>
    <v-text-field
      v-model="formData.cost"
      v-validate="'required'"
      :error-messages="errors.collect('cost')"
      :label="dictionary.attributes.cost"
      data-vv-name="cost"
      required
    ></v-text-field>
    <v-text-field
      v-model="formData.status"
      v-validate="'required'"
      :error-messages="errors.collect('status')"
      :label="dictionary.attributes.status"
      data-vv-name="status"
      required
    ></v-text-field>
    <div class="mt-5 d-flex">
      <v-spacer></v-spacer>
      <span v-if="!saving">
        <v-btn depressed text type="reset" @click="close">Clear</v-btn>
        <v-btn depressed color="accent" class="ml-2" type="submit">Save</v-btn>
      </span>
      <v-btn depressed color="accent" class="ml-2" disabled v-if="saving">
        <v-progress-circular indeterminate size="12" width="1" class="mr-1"></v-progress-circular>
        <span>Saving...</span>
      </v-btn>
    </div>
  </form>
</template>
<script>
import { mapActions } from 'vuex';
import types from '@/store/types';

export default {
  name: 'estimate-form',

  $_veeValidate: {
    validator: 'new',
  },

  props: {
    formData: {
      type: Object,
      default() {
        return {
          title: '',
          cost: 0,
          status: 'estimate',
        };
      },
    },
  },

  data: () => ({
    autofocus: true,
    saving: false,
    dictionary: {
      attributes: {
        title: 'Title',
        cost: 'Cost',
        status: 'Status',
      },
    },
  }),

  computed: {},

  mounted() {
    this.$validator.localize('en', this.dictionary);
    this.autofocus = true;
  },

  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saving = true;
          this[this.formData.id ? 'updateEstimate' : 'addEstimate'](this.formData).then(
            () => {
              this.$emit('save');
            },
          ).catch(() => {}).finally(() => {
            this.saving = false;
          });
        }
      });
    },
    close() {
      this.$emit('close');
    },
    clear() {
      this.$validator.reset();
    },
    ...mapActions('db', {
      addEstimate: types.CREATE_ESTIMATE,
      updateEstimate: types.UPDATE_ESTIMATE,
    }),
  },
};
</script>
